import React from 'react';
import { motion } from 'framer-motion';
import { FiUserCheck, FiSearch, FiLayout, FiCode, FiLink, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const sopSteps = [
  {
    title: "Entity Identification",
    step: "01",
    desc: "We verify your 'Hard Data'—Physical address, licenses, and certifications—to prove to AI you are a real, authoritative entity.",
    icon: FiUserCheck,
    color: "bg-blue-600"
  },
  {
    title: "Intent-to-Prompt Research",
    step: "02",
    desc: "We move beyond keywords to 'Prompts.' We optimize for the exact questions Alberta homeowners ask AI assistants.",
    icon: FiSearch,
    color: "bg-orange-600"
  },
  {
    title: "Answer-First Structure",
    step: "03",
    desc: "Following the 50-Word Rule, we place direct answers at the top of your pages to capture RAG-based AI snippets.",
    icon: FiLayout,
    color: "bg-green-600"
  },
  {
    title: "Technical Schema",
    step: "04",
    desc: "Implementation of FAQPage, HowTo, and Speakable Schema so AI can 'parse' your site without manual reading.",
    icon: FiCode,
    color: "bg-purple-600"
  },
  {
    title: "The Citation Loop",
    step: "05",
    desc: "We secure unlinked brand mentions and local Alberta citations to harden your authority score.",
    icon: FiLink,
    color: "bg-red-600"
  }
];

const AEOSOP = ({ city }) => {
  return (
    <section className="py-24 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-20">
          <h2 className="text-orange-500 font-black uppercase tracking-widest text-sm mb-4">Master SOP</h2>
          <h3 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Our {city} AEO Implementation Framework
          </h3>
          <p className="text-slate-400 text-lg max-w-2xl">
            How we move your business from a simple website to a verified AI authority cited by ChatGPT, Gemini, and Perplexity.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-4">
          {sopSteps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className="relative group p-6 bg-slate-800/50 border border-slate-700 rounded-3xl hover:bg-slate-800 transition-all"
            >
              <div className="text-5xl font-black text-slate-700/30 mb-6 group-hover:text-orange-500/20 transition-colors">
                {step.step}
              </div>
              <div className={`w-12 h-12 ${step.color} text-white rounded-xl flex items-center justify-center mb-6 shadow-lg`}>
                <SafeIcon icon={step.icon} className="text-xl" />
              </div>
              <h4 className="text-xl font-bold text-white mb-4 leading-tight">{step.title}</h4>
              <p className="text-slate-400 text-sm leading-relaxed">{step.desc}</p>
              
              {i < 4 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10 text-slate-700">
                  <SafeIcon icon={FiCheckCircle} className="text-xl" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AEOSOP;